import { ApolloClientFactory } from './apolloClientFactory';
import gql from 'graphql-tag';

const query = gql`
  query {
    staticVouchers {
      id
      voucherGroup {
        id
        amount
        active
        
        minimumPriceOfSingleItem
        maximumPriceOfSingleItem
        minimumPriceOfOrder
        maximumPriceOfOrder

        minimumPricesOfSingleItem {
          currencyId
          priceWithout
          recommendedPriceWithout
        }
        maximumPricesOfSingleItem {
          currencyId
          priceWithout
          recommendedPriceWithout
        }
        minimumPricesOfOrder {
          currencyId
          priceWithout
          recommendedPriceWithout
        }
        maximumPricesOfOrder {
          currencyId
          priceWithout
          recommendedPriceWithout
        }

        applyToDiscountedGoods

        freeShipping {
          id
        }

        customerGroups {
          id
        }
      }
    }
  }
`;

export const fetchStaticDiscounts = async () => {
  const client = ApolloClientFactory.GetClient();

  const discounts = await client.query({ query });

  return (discounts.data as any).staticVouchers;
};



// WEBPACK FOOTER //
// ./src/domain/fetchStaticDiscounts.ts